import { AxiosPromise } from 'axios'
import client from '@/shared/apis/client'
import type { PrescriptionReadingResponse } from '../types'

// 現在状態の取得。back GET /api/education/<id>/prescription-reading/
export const getPrescriptionReading = (
  yakurekiId: string
): AxiosPromise<PrescriptionReadingResponse> => {
  return client.get(`/api/education/${yakurekiId}/prescription-reading/`)
}

// 自分の読みを提出し AI 講評の生成を起こす。back POST（processing envelope を返す）。
export const submitReading = (
  yakurekiId: string,
  reading: string
): AxiosPromise<PrescriptionReadingResponse> => {
  return client.post(`/api/education/${yakurekiId}/prescription-reading/`, {
    reading,
  })
}
